import { Model } from "./Model";
import { Player } from "./Index";
import { CardType } from "../enums/Index";

export interface Card extends Model {
	cardType: CardType
	fixtureId: number;
	playerId: number;
	player: Player
}

export class Card implements Card {

	constructor(data?: Partial<Card>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}